<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-offset-2 is-8">
            <div class="box">
              <h1 class="title">ユーザー情報編集</h1>
              <div class="field">
                <label class="label">ログインユーザー</label>
                <div class="control">
                  <input class="input" type="text" v-model="inputForm.username" disabled>
                </div>
              </div>
              <div class="field">
                <label class="label">表示名</label>
                <div class="control">
                  <input class="input" type="text" placeholder="表示名" v-model="inputForm.dispname">
                </div>
              </div>
              <div class="field">
                <div>
                  <label for="lable" class="checkbox">
                    <input type="checkbox" id="admincheck" v-model="inputForm.permissions.admin" v-bind:disabled="user.id === $route.params.memberId">
                    管理者権限
                  </label>
                </div>
                <div v-if="user.permission.admin">
                  <label for="lable" class="checkbox">
                    <input type="checkbox" id="admincheck" v-model="inputForm.permissions.sub_admin" v-bind:disabled="user.id === $route.params.memberId">
                    補助管理者
                  </label>
                </div>
              </div>
              <div class="field">
                <router-link :to="{ name: 'mypage', params: { memberId: inputForm.id }}">
                  <a class="button">パスワードの変更</a>
                </router-link>
                &nbsp;&nbsp;
                <button v-if="inputForm.deleted_at === '0'" class="button is-danger" v-on:click="disable" v-bind:disabled="user.id === $route.params.memberId">無効にする</button>
                <button v-else class="button is-primary" v-on:click="enable">有効にする</button>
                &nbsp;&nbsp;
              </div>
              <button class="button is-link" v-on:click.prevent="update">確　定</button>
              &nbsp;&nbsp;
              <router-link to="/settings/members">
                <span class="button is-primary">
                  <span class="icon"><i class="fa fa-backward"></i></span>&nbsp;&nbsp;戻　る
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data: function(){
    return {
      showModal: false,
      inputForm: {
        id: 0,
        username: '',
        dispname: '',
        permissions: {
          admin: false,
          super_user: false,
          sub_admin: false,
        },
        deleted_at: 0
      },
      hasMessage: false,
      message: '',
      isError: false,
      isEdit: false,
      isSuper_user: false,
    }
  },
  computed:{
    ...mapGetters({
      getUser: 'item/getUser'
    }),
    ...mapState({
      apiStatus: state => state.item.apiStatus,
      user: state => state.auth.user,
    })
  },
  mounted (){
    this.$set(this, 'inputForm', this.getUser(this.$route.params.memberId))
  },
  methods: {
    async update() {
      if(this.inputForm.dispname ===""){
        this.$swal({
          title: '確認',
          text: '表示名を入力してください。',
          icon: 'error',
          confirmButtonText: '戻る',
        })
        return false
      }
      await this.$store.dispatch('item/updateUser', this.inputForm)
      if(this.apiStatus){
        this.$swal({
          position: 'top-end',
          icon: 'success',
          title: 'データを更新しました。',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    disable() {
      this.$set(this.inputForm, 'deleted_at', '1')
      this.update()
    },
    enable() {
      this.$set(this.inputForm, 'deleted_at', '0')
      this.update()
    }
  }
}
</script>